var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.btnColor,attrs:{"disabled":_vm.disabled}},[_vm._t("default"),(_vm.cartIcon)?_c('img',{attrs:{"src":require("../assets/images/cart.svg"),"alt":"Cart Icon"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }